import letterNamingAndSoundsConfig from "./customConfigs/letterNamingAndSoundsConfig";

export default function getCustomConfigurations(assessmentTag) {
  switch(assessmentTag) {
    case "ASSESSMENT-GREENVILLE":
      return [letterNamingAndSoundsConfig];
    default:
      return [];
  }
}